<div class="p-4">
  <p class="mb-3">{{ "QUOTE.DRAWING.DIALOG.REVOKE_DESCRIPTION" | translate }}</p>
  <p class="text-color-secondary text-sm mb-4">{{ "QUOTE.DRAWING.DIALOG.REVOKE_CONSEQUENCE" | translate }}</p>

  <div class="flex justify-content-end gap-2">
    <p-button [label]="'QUOTE.DRAWING.DIALOG.CANCEL' | translate" [text]="true" (onClick)="closeDialog()" />
    <p-button [label]="'QUOTE.DRAWING.DIALOG.REVOKE_CONFIRM' | translate" severity="danger" (onClick)="confirm()" />
  </div>
</div>
